import React from 'react';
import VirtualOfficePage from '../components/VirtualOfficePage';

const VirtualOffice = () => {
  return <VirtualOfficePage />;
};

export default VirtualOffice;